const LABEL_TEMPLATE = `[type]||[logID]||[postID]||[wsTrack]||[selfAid]||[partnerUrl]||[additionalParams]`
let DEFAULT_LABEL_OPTIONS

try {
	DEFAULT_LABEL_OPTIONS = {
		logID: shared.options?.log?.id,
		postID: shared.options?.pid,
		wsTrack: shared.options?.log?.wsl,
		selfAid: shared.options?.maid,
	}
} catch (error) {
	throw new Error('Fail to create DEFAULT_LABEL_OPTIONS: ', error)
}

const generateStatsLabelString = (customOptions = {}) => {
	const { additionalParams = {}, ...rest } = customOptions

	const options = {
		...DEFAULT_LABEL_OPTIONS,
		...rest,
		additionalParams: JSON.stringify(additionalParams),
	}

	// Create string from values of options
	const labelString = Object.entries(options).reduce(
		(prev, [key, value]) => prev.replace(`[${key}]`, value),
		LABEL_TEMPLATE
	)
	return labelString
}

export default generateStatsLabelString
